import {Injectable} from '@angular/core';
import {HttpClient} from '@angular/common/http';
import {HoomvipStorage} from '../hoomvip-storage/hoomvip-storage.service';
import {Observable, map} from 'rxjs';
import {ContractType} from '../../shared/models/contract-type.model';
import {ApiConfigService} from './api.config.service';
import {HTTP_CACHE_TTL_MS, HttpCacheService} from '../services/http-cache.service';

type GetContractTypesResponse = {
  contract_types?: ContractType[];
};

@Injectable({providedIn: 'root'})
export class ContractTypeService {
  constructor(private http: HttpClient, private hoomvipStorage: HoomvipStorage, private apiConfigService: ApiConfigService, private cache: HttpCacheService) {
  }

  getContractTypes(): Observable<ContractType[]> {
    const code = this.hoomvipStorage.getCode();
    const url = this.apiConfigService.getContractTypeUrl();
    const key = `ContractTypeService:POST:${url}:code=${encodeURIComponent(code ?? '')}`;

    return this.cache.getOrSet<GetContractTypesResponse>(
      key,
      HTTP_CACHE_TTL_MS.UNIMPORTANT,
      () => this.http.post<GetContractTypesResponse>(url, {code})
    ).pipe(
      map((res) => Array.isArray(res?.contract_types) ? res.contract_types : [])
    );
  }

}
